import { type RequestOptions, request } from '@/services/request';
import type {
  BindingCodeIssued,
  BindingCodeRequest,
  BindingVerifyRequest,
  BindingVerifyResult,
  ContactBinding,
} from './binding';
import type {
  AccountProfile,
  NotificationPage,
  NotificationParams,
  NotificationSettings,
  PasswordUpdate,
  ProfileUpdate,
} from './types';

async function accountRequest<T>(path: string, options?: RequestOptions) {
  const response = await request<{ success: boolean; data: T }>(
    `/api/account/${path}`,
    { ...options, skipErrorHandler: true },
  );
  return response.data;
}
export const getProfile = (signal?: AbortSignal) =>
  accountRequest<AccountProfile>('profile', { signal });
export const updateProfile = (data: ProfileUpdate) =>
  accountRequest<AccountProfile>('profile', { method: 'PATCH', data });
export const updateAvatar = (dataUrl: string) =>
  accountRequest<AccountProfile>('avatar', { method: 'PATCH', data: { dataUrl } });
export const getBindings = (signal?: AbortSignal) =>
  accountRequest<ContactBinding[]>('bindings', { signal });
export const sendBindingCode = (data: BindingCodeRequest) =>
  accountRequest<BindingCodeIssued>('bindings/code', { method: 'POST', data });
export const verifyBinding = (data: BindingVerifyRequest) =>
  accountRequest<BindingVerifyResult>('bindings/verify', { method: 'POST', data });
export const getSubscriptions = (signal?: AbortSignal) =>
  accountRequest<NotificationSettings>('notification-settings', { signal });
export const updateSubscriptions = (data: NotificationSettings) =>
  accountRequest<NotificationSettings>('notification-settings', {
    method: 'PATCH',
    data,
  });
export const changePassword = (data: PasswordUpdate) =>
  accountRequest<{ updated: boolean }>('password', { method: 'POST', data });
export const getNotifications = (params: NotificationParams, signal?: AbortSignal) =>
  accountRequest<NotificationPage>('notifications', { params, signal });
export const markRead = (id: string) =>
  accountRequest(`notifications/${encodeURIComponent(id)}/read`, { method: 'PATCH' });
export const markAllRead = () =>
  accountRequest('notifications/read-all', { method: 'POST' });
